import { render, staticRenderFns } from "./Shanghai.vue?vue&type=template&id=160b3acc&scoped=true"
import script from "./Shanghai.vue?vue&type=script&lang=js"
export * from "./Shanghai.vue?vue&type=script&lang=js"
import style0 from "./Shanghai.vue?vue&type=style&index=0&id=160b3acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b3acc",
  null
  
)

export default component.exports